export const OPERATION_TYPE =[
    { value: 0, label: '' },
    { value: 1, label: '添加' },
    { value: 2, label: '删除' },
    { value: 3, label: '修改' }
];